document.addEventListener('DOMContentLoaded', function () {
  const variantsData = JSON.parse(variants);

  var splide = new Splide('.product-media-mobile', {
    type: 'slide',
    rewind: false,
    pagination: true,
    arrows: false,
    perPage: 1,
    perMove: 1,
  });
  splide.mount();

  if (document.querySelector('.wear-with-content-slider')) {
    const wearWithSlidesCount = document.querySelectorAll('.wear-with-content-slider .wear-with-item').length;
    const shouldShowWearWithArrows = wearWithSlidesCount > 2;
    const shouldEnableWearWithSlider = wearWithSlidesCount > 1;

    var wearWithContent = new Splide('.wear-with-content-slider', {
      type: 'slide',
      rewind: false,
      pagination: false,
      arrows: shouldShowWearWithArrows,
      perPage: 2,
      perMove: 1,
      gap: '20px',
      breakpoints: {
        768: {
          perPage: 2,
          perMove: 1,
          gap: '12px',
          arrows: false,
          pagination: false,
          drag: shouldEnableWearWithSlider ? 'free' : false,
          snap: false,
          type: 'slide',
          trimSpace: false,
          rewind: false,
        },
      },
    });
    const scrollbarWearWith = document.querySelector('.wear-with-scrollbar');
    const handleWearWith = document.querySelector('.wear-with-scrollbar__handle');

    wearWithContent.on('mounted move moved drag dragging dragged scroll scrolled resize updated refresh', updateScrollbarWearWith);
    wearWithContent.mount();

    let isDraggingWearWith = false;
    let startXWearWith, startLeftWearWith;

    function getWearWithProgressRate(endWearWith) {
      if (endWearWith <= 0) {
        return 0;
      }

      const currentIndex = wearWithContent.index || 0;
      return Math.max(0, Math.min(currentIndex / endWearWith, 1));
    }

    function updateScrollbarWearWith() {
      if (!scrollbarWearWith || !handleWearWith) return;

      const totalSlidesWearWith = wearWithContent.length;
      const visibleSlidesWearWith = Number(wearWithContent.options.perPage) || 1;
      const endWearWith = wearWithContent.Components.Controller.getEnd();

      scrollbarWearWith.style.display = '';

      if (totalSlidesWearWith <= visibleSlidesWearWith || endWearWith <= 0) {
        handleWearWith.style.width = '100%';
        handleWearWith.style.left = '0%';
        return;
      }

      const handleWidthWearWith = (visibleSlidesWearWith / totalSlidesWearWith) * 100;
      const rate = getWearWithProgressRate(endWearWith);
      const maxScrollableDistance = 100 - handleWidthWearWith;

      handleWearWith.style.width = `${handleWidthWearWith}%`;
      handleWearWith.style.left = `${Math.min(rate * maxScrollableDistance, maxScrollableDistance)}%`;
    }

    if (scrollbarWearWith && handleWearWith) {
      handleWearWith.addEventListener('mousedown', (event) => {
        isDraggingWearWith = true;
        startXWearWith = event.clientX;
        startLeftWearWith = parseFloat(handleWearWith.style.left || '0');
        document.body.style.userSelect = 'none';
      });

      document.addEventListener('mousemove', (event) => {
        if (!isDraggingWearWith) return;
        const scrollbarWidthWearWith = scrollbarWearWith.offsetWidth;
        const handleWidthWearWith = handleWearWith.offsetWidth;
        const deltaX = event.clientX - startXWearWith;
        const maxScrollableDistance = scrollbarWidthWearWith - handleWidthWearWith;
        let newLeft = startLeftWearWith + (deltaX / scrollbarWidthWearWith) * 100;
        newLeft = Math.max(0, Math.min(newLeft, (maxScrollableDistance / scrollbarWidthWearWith) * 100));
        handleWearWith.style.left = `${newLeft}%`;
        const totalSlidesWearWith = wearWithContent.length;
        const visibleSlidesWearWith = Number(wearWithContent.options.perPage) || 1;
        const endWearWith = wearWithContent.Components.Controller.getEnd();

        if (totalSlidesWearWith <= visibleSlidesWearWith || endWearWith <= 0) return;

        const maxScrollablePercent = 100 - (visibleSlidesWearWith / totalSlidesWearWith) * 100;
        if (maxScrollablePercent <= 0) return;

        const newIndex = Math.round((newLeft / maxScrollablePercent) * endWearWith);
        wearWithContent.go(newIndex);
      });

      document.addEventListener('mouseup', () => {
        if (isDraggingWearWith) {
          isDraggingWearWith = false;
          document.body.style.userSelect = '';
          updateScrollbarWearWith();
        }
      });
    }
  }

  var zoomSplide = new Splide('.product-media-desktop-zoom', {
    type: 'slide',
    pagination: false,
    arrows: true,
    perPage: 1,
    perMove: 1,
  });
  zoomSplide.mount({ getSlideNumber });

  document.querySelectorAll('.selected-option').forEach(function (selectedOption) {
    selectedOption.addEventListener('click', function () {
      this.nextElementSibling.classList.toggle('show-options');
      this.classList.toggle('active');
    });
  });

  document.querySelectorAll('.option-set').forEach(function (optionSet) {
    const sizeDisplay = optionSet.querySelector('.selected-option .selected-size-display');
    const plainSpan = optionSet.querySelector('.selected-option > span:not(.selected-size-display)');

    const selectedValue = sizeDisplay
      ? sizeDisplay.getAttribute('data-size-value').trim()
      : plainSpan
      ? plainSpan.textContent.trim()
      : null;

    if (!selectedValue) return;

    optionSet.querySelectorAll('.select-other-options li[data-value]').forEach(function (li) {
      li.classList.remove('selected');
      if (li.getAttribute('data-value').trim() === selectedValue) {
        li.classList.add('selected');
      }
    });
  });

  document.querySelectorAll('.size-option-link').forEach(function (sizeguide, index) {
    sizeguide.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();

      const optionSet = this.closest('.option-set');
      if (optionSet) {
        const optionList = optionSet.querySelector('.select-other-options');
        const selectedOption = optionSet.querySelector('.selected-option');

        if (optionList) optionList.classList.remove('show-options');
        if (selectedOption) selectedOption.classList.remove('active');
      }

      const sizeGuidePopup = document.querySelector('.size-guide-popup');
      sizeGuidePopup.classList.add('active');
      document.querySelector('body').classList.toggle('overflow-hidden-true');
    });
  });

  document.querySelectorAll('.size-guide-popup .close-icon').forEach(function (closeBtn) {
    closeBtn.addEventListener('click', function () {
      const sizeGuidePopup = document.querySelector('.size-guide-popup');
      sizeGuidePopup.classList.remove('active');
      document.querySelector('body').classList.remove('overflow-hidden-true');
    });
  });

  document.querySelectorAll('.product-active-zoom').forEach(function (productimage) {
    productimage.addEventListener('click', function () {
      var mediaId = this.dataset.index;
      console.log('Media iD ', mediaId);
      var index = parseInt(mediaId, 10);
      document.querySelector('.zoom-feature').classList.add('active-zoom');
      document.querySelector('body').classList.add('overflow-hidden-true');
      setTimeout(() => {
        zoomSplide.go(index); // jump to the slide
      }, 100);
    });
  });

  document.querySelectorAll('.zoom-feature .close-zooom-popup').forEach(function (closeBtn) {
    closeBtn.addEventListener('click', function () {
      document.querySelector('.zoom-feature').classList.remove('active-zoom');
      document.querySelector('body').classList.remove('overflow-hidden-true');
    });
  });

  document.querySelectorAll('.product-bullet').forEach(function (bullet) {
    bullet.addEventListener('click', function () {
      document.querySelectorAll('.product-bullet').forEach(function (b) {
        b.classList.remove('product-bullet--active');
      });
      this.classList.add('product-bullet--active');

      const mediaId = this.dataset.id;
      const mediaItem = document.querySelector(`.product-media-item[data-id="${mediaId}"]`);
      if (mediaItem) {
        mediaItem.scrollIntoView({ behavior: 'smooth' });
      }
    });
  });

  document.querySelectorAll('.content-header').forEach(function (header, index) {
    if (index === 0) {
      header.classList.add('first-child');
    }
    header.addEventListener('click', function () {
      const content = this.nextElementSibling;
      this.classList.toggle('active');
      if (content.style.maxHeight) {
        content.style.maxHeight = null;
        content.style.visibility = 'hidden';
        content.classList.remove('active');
      } else {
        content.style.maxHeight = content.scrollHeight + 'px';
        content.style.visibility = 'visible';
        content.classList.add('active');
      }
    });
  });

  document.querySelectorAll('.select-other-options li').forEach(function (option) {
    option.addEventListener('click', function () {
      const selectedOption = this.dataset.value;
      const selectedOptionContainer = this.closest('.option-set');
      const selectedOptionDisplay = selectedOptionContainer.querySelector('.selected-option');
      const selectedSizeDisplay = selectedOptionDisplay.querySelector('.selected-size-display');

      if (selectedSizeDisplay) {
        selectedSizeDisplay.dataset.sizeValue = selectedOption;
      } else {
        selectedOptionDisplay.querySelector('span').textContent = selectedOption;
      }
      selectedOptionContainer.querySelector('.select-other-options').classList.remove('show-options');
      selectedOptionDisplay.classList.remove('active');

      selectedOptionContainer.querySelectorAll('.select-other-options li').forEach(function (li) {
        li.classList.remove('selected');
      });
      if (this.dataset.value) {
        this.classList.add('selected');
      }

      updateVariant();
      // Optionally, you can trigger a change event or update the variant selection here
    });
  });

  document.querySelectorAll('li.select-data-content').forEach(function (option) {
    option.addEventListener('click', function () {
      const dataIndex = this.dataset.index;
      const contentContainer = this.closest('.data-content-wrapper').querySelectorAll('.data-content');
      const tabSlectors = this.closest('.data-content-wrapper').querySelectorAll('li.select-data-content');

      tabSlectors.forEach(function (tab) {
        tab.classList.remove('active');
      });
      this.classList.add('active');

      contentContainer.forEach(function (content) {
        content.style.display = 'none';
      });

      const selectedContent = this.closest('.data-content-wrapper').querySelector(
        `.data-content[data-index="${dataIndex}"]`
      );
      if (selectedContent) {
        selectedContent.style.display = 'block';
      }
    });
  });

  const fixedBox = document.querySelector('.product-bullet-wrapper');
  const imageSection = document.querySelector('.product-media-wrapper');

  window.addEventListener('scroll', () => {
    const sectionRect = imageSection.getBoundingClientRect();

    // Section top < viewport bottom and section bottom > 0 → within viewport
    if (sectionRect.top <= 0 && sectionRect.bottom >= 400) {
      fixedBox.classList.remove('absolute');
      fixedBox.style.position = 'fixed';
    } else if (sectionRect.bottom < 400) {
      fixedBox.classList.add('absolute');
      fixedBox.style.position = 'absolute';
    } else {
      fixedBox.classList.remove('absolute');
      fixedBox.style.position = 'absolute';
    }

    const images = document.querySelectorAll('.product-media-item[data-id]');
    let topImage = null;
    let topOffset = Infinity;

    images.forEach((img) => {
      const rect = img.getBoundingClientRect();
      // Only consider images visible in viewport
      if (rect.top >= 0 && rect.top < topOffset) {
        topOffset = rect.top;
        topImage = img;
      }
    });

    if (topImage) {
      document.querySelectorAll('.product-bullet').forEach(function (b) {
        b.classList.remove('product-bullet--active');
      });
      const activeBullet = document.querySelector(`.product-bullet[data-id="${topImage.getAttribute('data-id')}"]`);
      if (activeBullet) {
        activeBullet.classList.add('product-bullet--active');
      }
    }
  });

  let scale = 2.5;

  document.querySelectorAll('.zoom-feature .product-media-item').forEach(function (productMediaItem) {
    const container = productMediaItem;
    const img = container.querySelector('.product-media-image');

    container.addEventListener('mouseenter', () => {
      img.style.transform = `scale(${scale})`;
    });

    container.addEventListener('mouseleave', () => {
      img.style.transform = `scale(1) translate(0px, 0px)`;
    });

    container.addEventListener('mousemove', (e) => {
      const rect = container.getBoundingClientRect();

      // mouse position inside container (0 to 1)
      const mouseX = (e.clientX - rect.left) / rect.width;
      const mouseY = (e.clientY - rect.top) / rect.height;

      // max move limits
      const maxMoveX = (rect.width * (scale - 1)) / 2;
      const maxMoveY = (rect.height * (scale - 1)) / 2;

      // calculate translate
      const moveX = (mouseX - 0.5) * 2 * maxMoveX;
      const moveY = (mouseY - 0.5) * 2 * maxMoveY;

      img.style.transform = `translate(${-moveX}px, ${-moveY}px) scale(${scale})`;
    });
  });

  let lastScrollTop = 0;

  if (window.scrollY > 0) {
    document.querySelector('.product-sticky-bar').classList.add('remove');
  } else {
    document.querySelector('.product-sticky-bar').classList.remove('remove');
  }

  window.addEventListener('scroll', function () {
    const st = window.pageYOffset || document.documentElement.scrollTop;

    if (st > lastScrollTop) {
      document.querySelector('.product-sticky-bar').classList.add('remove');
    } else {
      document.querySelector('.product-sticky-bar').classList.remove('remove');
    }

    lastScrollTop = st <= 0 ? 0 : st; // Prevent negative
  });

  document.querySelector('.view-360-link-mobile').addEventListener('click', function (e) {
    e.preventDefault();
    const popup = document.querySelector('.product-360-wrapper-popup');
    popup.classList.add('active');
  });

  document.querySelector('.product-360-wrapper-popup .close-360-popup').addEventListener('click', function () {
    const popup = document.querySelector('.product-360-wrapper-popup');
    popup.classList.remove('active');
  });

  function init360(wrapperRoot) {
    const wrapper = wrapperRoot.querySelector('.product-360-link-wrapper');
    const images = wrapper.querySelectorAll('.product-media-item');

    const bar = wrapperRoot.querySelector('.scroll-bar');
    const handle = wrapperRoot.querySelector('.scroll-bar-handle');

    if (!wrapper || !images.length || !bar || !handle) return;

    let index = 0;
    let rotationInterval = null;
    let isDragging = false;

    function showFrame(i) {
      images.forEach((img) => (img.style.zIndex = 1));
      images[i].style.zIndex = 2;
    }

    function positionToFrame(left) {
      const barWidth = bar.offsetWidth - handle.offsetWidth;
      const ratio = left / barWidth;
      return Math.min(images.length - 1, Math.max(0, Math.round(ratio * (images.length - 1))));
    }

    function frameToPosition(i) {
      const barWidth = bar.offsetWidth - handle.offsetWidth;
      return (i / (images.length - 1)) * barWidth;
    }

    // ------------------------------
    // DRAG START
    // ------------------------------
    function startDrag(e) {
      isDragging = true;
      e.preventDefault();
    }

    // ------------------------------
    // DRAG END
    // ------------------------------
    function endDrag() {
      isDragging = false;
    }

    // ------------------------------
    // DRAG MOVE (common logic)
    // ------------------------------
    function moveDrag(clientX) {
      const rect = bar.getBoundingClientRect();
      let left = clientX - rect.left - handle.offsetWidth / 2;

      // Clamp inside scrollbar
      left = Math.max(0, Math.min(left, bar.offsetWidth - handle.offsetWidth));
      handle.style.left = left + 'px';

      index = positionToFrame(left);
      showFrame(index);
    }

    // Mouse
    handle.addEventListener('mousedown', startDrag);
    document.addEventListener('mouseup', endDrag);
    document.addEventListener('mousemove', (e) => {
      if (!isDragging) return;
      moveDrag(e.clientX);
    });

    // Touch
    handle.addEventListener('touchstart', (e) => startDrag(e), { passive: false });
    document.addEventListener('touchend', endDrag);
    document.addEventListener(
      'touchmove',
      (e) => {
        if (!isDragging) return;
        moveDrag(e.touches[0].clientX);
      },
      { passive: false }
    );

    // ------------------------------
    // AUTOPLAY
    // ------------------------------
    function rotateImagesOnce() {
      showFrame(index);
      handle.style.left = frameToPosition(index) + 'px';

      index++;

      if (index >= images.length) {
        clearInterval(rotationInterval);
        rotationInterval = null;
      }
    }

    function startRotation() {
      if (rotationInterval || isDragging) return;
      index = 0;
      rotationInterval = setInterval(rotateImagesOnce, 100);
    }

    // Start autoplay when wrapper enters viewport
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) startRotation();
      });
    });

    observer.observe(wrapper);
  }

  // ----------------------------------
  // INIT BOTH WRAPPERS SAFELY
  // ----------------------------------

  init360(document.querySelector('.product-media'));
  init360(document.querySelector('.product-360-wrapper-popup'));

  document.querySelectorAll('.view-360-link').forEach(function (link) {
    link.addEventListener('click', function (e) {
      e.preventDefault();
      if (window.innerWidth <= 768) {
        init360(document.querySelector('.product-360-wrapper-popup'));
      } else {
        init360(document.querySelector('.product-media'));
      }
    });
  });

  function updateAddToCartButtons(isAvailable) {
    document.querySelectorAll('.add_to_cart, .add_to_bag').forEach(function (button) {
      if (!button) return;

      const availableLabel = button.dataset.availableLabel || 'Add to Cart';
      const unavailableLabel = button.dataset.unavailableLabel || 'Sold Out';

      button.disabled = !isAvailable;
      button.textContent = isAvailable ? availableLabel : unavailableLabel;
    });
  }

  function updateVariant() {
    const addToCartText = window.variantStrings?.addToCart || 'Add to Cart';
    const soldOutText = window.variantStrings?.soldOut || 'Sold Out';
    const selectedOptions = [];
    let productSelection = document.querySelectorAll('.product-meta .option-set');
    if (window.innerWidth <= 768) {
      productSelection = document.querySelectorAll('.product-sticky-bar .option-set');
    }
    productSelection.forEach(function (optionSet) {
      const sizeDisplay = optionSet.querySelector('.selected-option .selected-size-display');
      let selectedOption = '';

      if (sizeDisplay) {
        selectedOption = (sizeDisplay.dataset.sizeValue || '').trim();
      }

      if (!selectedOption) {
        const selectedOptionNode = optionSet.querySelector('.selected-option > span');
        selectedOption = selectedOptionNode ? selectedOptionNode.textContent.trim() : '';
      }

      selectedOptions.push(selectedOption);
    });

    const variantKey = selectedOptions.join(' / ');
    const variant = variantsData.find((v) => v.name.indexOf(variantKey) !== -1);

    console.log('Selected Variant Key:', variantKey, 'Variant:', variant);

    if (variant) {
      document.querySelectorAll('[name="id"]').forEach(function (input) {
        input.value = variant.id;
      });
      if (variant.compare_at_price > variant.price) {
        let discount = discountPercentage(variant.compare_at_price, variant.price);
        document.querySelector('.product-price .product-price--current').textContent = formatPrice(variant.price);
        document.querySelector('.product-price .product-price--compare').textContent = formatPrice(
          variant.compare_at_price
        );
        document.querySelector('.product-price .product-price--compare').style.display = 'inline';
        document.querySelector('.product-discount-badge').textContent = `${discount}% Off`;
        document.querySelector('.product-discount-badge').style.display = 'block';
      } else {
        document.querySelector('.product-price .product-price--current').textContent = formatPrice(variant.price);
        document.querySelector('.product-price .product-price--compare').style.display = 'none';
        document.querySelector('.product-discount-badge').style.display = 'none';
      }

      if (variant.available) {
        document.querySelector('.add_to_cart').disabled = false;
        document.querySelector('.add_to_cart').textContent = addToCartText;
      } else {
        document.querySelector('.add_to_cart').disabled = true;
        document.querySelector('.add_to_cart').textContent = soldOutText;
      }
      updateAddToCartButtons(variant.available);
    }
  }

  function discountPercentage(originalPrice, discountedPrice) {
    return Math.round(((originalPrice - discountedPrice) / originalPrice) * 100);
  }
function formatPrice(price) {
  const amount = price / 100;
  const isWholeNumber = amount % 1 === 0;

  return new Intl.NumberFormat(
    `${window.Shopify.locale}-${window.Shopify.country}`,
    {
      style: 'currency',
      currency: window.Shopify.currency.active,
      minimumFractionDigits: isWholeNumber ? 0 : 2,
      maximumFractionDigits: 2,
    }
  ).format(amount);
}

  function getSlideNumber(Splide, Components) {
    let elm;

    return {
      mount() {
        elm = document.querySelector('.slide-counter span');

        this.setNumber(Splide.index + 1);

        this.bind();
      },

      bind() {
        Splide.on('move', (newIndex) => {
          this.setNumber(newIndex + 1);
        });
      },

      setNumber(number) {
        const content = `${number}`;

        if (elm.textContent !== undefined) {
          elm.textContent = content;
        } else {
          elm.innerText = content;
        }
      },
    };
  }
});
